import React from 'react';
import infoIcon from './info_icon.svg';

const InfoIcon = () => <img style={{marginBottom: '2px'}} src={infoIcon} alt=""/>;

export default InfoIcon;
